<template>
  <div>
    <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data">
      <i><img :src="$getThemeImagePath('no-data.png')" alt=""></i>
      <p>{{ $t('Bao.no_relevant_data_records') }}</p>
      <span>{{ $t('Bao.search_results_are_empty') }}</span>
    </div>

    <template v-else-if="record.length > 0">
      <div class="history-list-pc">
        <table class="history-table">
          <thead>
            <tr>
              <th scope="col" class="text-center">
                {{ $t("Bao.plateform_name") }}
                <br>
                {{ $t("Bao.game") }}
              </th>
              <th scope="col" class="text-center">
                {{ $t("Bao.game_finish_at") }}
              </th>
              <th scope="col" class="text-align-R">
                {{ $t("Bao.bet_amount") }}
              </th>
              <th scope="col" class="text-align-R">
                {{ $t('Bao.bet_degree') }}
              </th>
              <th scope="col" class="text-align-R">
                {{ $t("Bao.win_amount") }}
              </th>
              <th scope="col" class="text-center">
                {{ $t("Bao.status") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in record" :key="key">
              <td class="index text-center">
                {{ item.game_provider_name }}
                <br>
                {{ item.game_name }}
              </td>
              <td class="product text-center">
                {{ item.formattedTime }}
              </td>
              <td class="ingredient text-align-R pr-3">
                {{ item.bet_amount | numberFormatExtended }}
                <img class="his-icon" :src="getWalletImagePath(item)">
              </td>
              <td class="price text-align-R pr-3">
                {{ calculateBetDegree(item.win_amount, item.bet_amount) }}
              </td>
              <td class="text-align-R pr-3">
                {{ item.win_amount | numberFormatExtended }}
                <img class="his-icon" :src="getWalletImagePath(item)">
              </td>
              <td class="text-center">
                {{ getStatusText(item.status) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="history-list-mobile">
        <ul class="history-list-container-mobile">
          <li v-for="(item, key) in record" :key="key" class="board board-list">
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.plateform_name") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.game_provider_name }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.game") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.game_name }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.game_finish_at") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.formattedTime }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.bet_amount") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.bet_amount | numberFormatExtended }}
                <img class="his-icon" :src="getWalletImagePath(item)">
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t('Bao.bet_degree') }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ calculateBetDegree(item.win_amount, item.bet_amount) }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.win_amount") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.win_amount | numberFormatExtended }}
                <img class="his-icon" :src="getWalletImagePath(item)">
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.status") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ getStatusText(item.status) }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BetHistory',
  filters: {
    numberFormatExtended(value) {
      if (!value) return '0'
      // Support up to 8 decimal places
      return parseFloat(value).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8
      })
    }
  },
  props: {
    record: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    firstLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    getStatusText() {
      return (status) => {
        switch (status) {
          case '1':
            return this.$t('Bao.bet_success')
          case '0':
            return this.$t('Bao.bet_pending')
          case '-1':
            return this.$t('Bao.bet_failed')
          default:
            return '-'
        }
      }
    }
  },
  created() {
    console.log(this.record)
  },
  methods: {
    calculateBetDegree(winAmount, betAmount) {
      if (!betAmount || parseFloat(betAmount) === 0) return '-'

      const ratio = parseFloat(winAmount) / parseFloat(betAmount)
      return ratio.toFixed(2) + 'x'
    },
    getWalletImagePath(item) {
      const currency = item.wallet_type
      if (!currency) {
        return this.$getThemeImagePath('default-crypto.svg')
      }

      if (currency === 'main' || currency === 'bonus') {
        return this.$getThemeImagePath('icon_jpy.svg')
      }

      return this.$getThemeImagePath(`crypto-${currency.toLowerCase()}.svg`)
    }
  }
}
</script>
